<template>
    <div class="offer_one_legend">
        <section class="one_cont">
            <h1>Tvorba cenovej ponuky</h1>
            <main class="first">
                <div class="info">
                    <div class="my_tooltip">
                        {{ $t('offer.internal_name_hint') }}
                    </div>
                    <div class="tooltip_hover info_icon">
                        <img src="/img/info_icon.svg" alt="" />
                    </div>
                </div>
                <div class="form-floating mt-1 mb-2" v-bind:class="{ error: this.errors.nazov == true }">
                    <input v-model="offer.nazov" type="text" class="form-control" id="floatingNazov"
                        :placeholder="$t('offer.internal_name_placeholder')" />
                    <label for="floatingNazov">{{ $t('offer.internal_name_label') }}<sup class="sup">*</sup></label>
                </div>
                <div class="info">
                    <div class="my_tooltip">
                        {{ $t('offer.title_hint') }}
                    </div>
                    <div class="tooltip_hover info_icon">
                        <img src="/img/info_icon.svg" alt="" />
                    </div>
                </div>
                <div class="form-floating mt-1 mb-2">
                    <input v-model="offer.verejny_nazov" type="text" class="form-control" id="floatingNazov"
                        placeholder="Nadpis cenovej ponuky" @focusin="activated_legend.verejny_nazov = true"
                        @focusout="activated_legend.verejny_nazov = false" />
                    <label for="floatingNazov">Nadpis cenovej ponuky</label>
                </div>
                <div class="form-floating" v-bind:class="{ error: this.errors.klient == true }">
                    <input v-model="klient" type="text" class="form-control" id="floatingNazov"
                        :placeholder="$t('offer.client_name_placeholder')" />
                    <label for="floatingNazov">{{ $t('offer.client_name_label') }}<sup class="sup">*</sup></label>
                    <svg class="lupa" width="23" height="23" viewBox="0 0 23 23" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <mask id="path-1-inside-1" fill="white">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M13.4947 6.4247C15.4129 8.4111 15.3577 11.5764 13.3713 13.4947C11.3849 15.4129 8.21953 15.3577 6.30129 13.3713C4.38304 11.3849 4.43829 8.21954 6.4247 6.30129C8.4111 4.38304 11.5764 4.4383 13.4947 6.4247ZM15.5589 14.0174C17.5266 11.3202 17.3321 7.51938 14.9334 5.03538C12.2478 2.25442 7.81634 2.17707 5.03538 4.86261C2.25442 7.54816 2.17706 11.9796 4.86261 14.7606C7.3123 17.2973 11.2147 17.5845 13.992 15.577L14.9187 16.5367L15.4306 17.0667L16.8199 18.5054L16.9713 18.3591L18.2586 17.1161L18.41 16.9698L17.0207 15.5311L16.5088 15.0011L15.5589 14.0174Z" />
                        </mask>
                        <path
                            d="M15.5589 14.0174L13.9432 12.8387L12.9522 14.1972L14.1203 15.4068L15.5589 14.0174ZM13.992 15.577L15.4307 14.1877L14.226 12.9402L12.8204 13.9561L13.992 15.577ZM14.9187 16.5367L16.3574 15.1473L14.9187 16.5367ZM15.4306 17.0667L16.8693 15.6774L15.4306 17.0667ZM16.8199 18.5054L15.3812 19.8947L16.7705 21.3334L18.2092 19.9441L16.8199 18.5054ZM16.9713 18.3591L15.582 16.9205L16.9713 18.3591ZM18.2586 17.1161L19.6479 18.5547L18.2586 17.1161ZM18.41 16.9698L19.7993 18.4085L21.238 17.0192L19.8487 15.5805L18.41 16.9698ZM17.0207 15.5311L15.582 16.9205L17.0207 15.5311ZM16.5088 15.0011L17.9475 13.6118L16.5088 15.0011ZM14.7606 14.9334C17.5416 12.2478 17.6189 7.81634 14.9334 5.03538L12.056 7.81401C13.207 9.00586 13.1738 10.9051 11.982 12.056L14.7606 14.9334ZM4.86261 14.7606C7.54815 17.5416 11.9796 17.6189 14.7606 14.9334L11.982 12.056C10.7901 13.207 8.89092 13.1738 7.73997 11.982L4.86261 14.7606ZM5.03538 4.86261C2.25442 7.54816 2.17706 11.9796 4.86261 14.7606L7.73997 11.982C6.58902 10.7901 6.62217 8.89092 7.81401 7.73997L5.03538 4.86261ZM14.9334 5.03538C12.2478 2.25442 7.81634 2.17707 5.03538 4.86261L7.81401 7.73997C9.00585 6.58902 10.9051 6.62217 12.056 7.81401L14.9334 5.03538ZM17.1747 15.1961C19.7054 11.7271 19.4576 6.84125 16.372 3.64606L13.4947 6.4247C15.2067 8.1975 15.3478 10.9133 13.9432 12.8387L17.1747 15.1961ZM16.372 3.64606C12.9192 0.0705403 7.22159 -0.0289119 3.64606 3.42393L6.4247 6.30129C8.4111 4.38304 11.5764 4.4383 13.4947 6.4247L16.372 3.64606ZM3.64606 3.42393C0.0705382 6.87677 -0.0289139 12.5744 3.42393 16.1499L6.30129 13.3713C4.38304 11.3849 4.43829 8.21954 6.4247 6.30129L3.64606 3.42393ZM3.42393 16.1499C6.57473 19.4127 11.5913 19.78 15.1636 17.1979L12.8204 13.9561C10.8382 15.3889 8.04987 15.182 6.30129 13.3713L3.42393 16.1499ZM12.5533 16.9664L13.48 17.926L16.3574 15.1473L15.4307 14.1877L12.5533 16.9664ZM13.48 17.926L13.9919 18.456L16.8693 15.6774L16.3574 15.1473L13.48 17.926ZM13.9919 18.456L15.3812 19.8947L18.2586 17.1161L16.8693 15.6774L13.9919 18.456ZM18.2092 19.9441L18.3606 19.7978L15.582 16.9205L15.4306 17.0667L18.2092 19.9441ZM18.3606 19.7978L19.6479 18.5547L16.8693 15.6774L15.582 16.9205L18.3606 19.7978ZM19.6479 18.5547L19.7993 18.4085L17.0207 15.5311L16.8693 15.6774L19.6479 18.5547ZM19.8487 15.5805L18.4594 14.1418L15.582 16.9205L16.9713 18.3591L19.8487 15.5805ZM18.4594 14.1418L17.9475 13.6118L15.0702 16.3904L15.582 16.9205L18.4594 14.1418ZM17.9475 13.6118L16.9976 12.6281L14.1203 15.4068L15.0702 16.3904L17.9475 13.6118Z"
                            fill="#DDE3E8" mask="url(#path-1-inside-1)" />
                    </svg>
                    <div v-if="is_sim_klient" class="klient_sim">
                        <span v-for="item in searchKlients" :key="item.id" @click="klient = item.nazov"
                            v-html="matchName(item.nazov)">
                        </span>
                        <div class="nothing" v-if="searchKlients.length == 0">
                            <div class="top">{{ $t('offer.no_client_found') }}</div>
                        </div>
                        <div v-if="premium.id || klients.length < 5" class="bottom" @click="addClientModal">
                            {{ $t('offer.add_client_prefix') }} “{{ klient }}”
                        </div>
                    </div>
                </div>
                <div class="last_klients">
                    <span v-for="item in update_last_klient" :key="item.id" @click="klient = item.nazov">
                        {{ item.nazov }}
                    </span>
                </div>
                <div class="info">
                    <div class="my_tooltip">
                        {{ $t('offer.client_data_hint') }}
                    </div>
                    <div class="tooltip_hover info_icon">
                        <img src="/img/info_icon.svg" alt="" />
                    </div>
                </div>
                <div class="client-info d-flex justify-content-between align-items-baseline">
                    <div class="form-floating textarea mt-1" style="width: 49%">
                        <textarea v-model="offer.udaje_klienta_lavo" class="form-control klient_udaje_top"
                            :placeholder="$t('offer.client_left_placeholder')" id="floatingTextarea2" @focusin="
                                activated_legend.udaje_klienta_left = true
                                " @focusout="
                                activated_legend.udaje_klienta_left = false
                                ">
                        </textarea>
                        <label for="floatingTextarea2">{{ $t('offer.client_left_label') }}</label>
                    </div>
                    <div class="form-floating textarea mt-1" style="width: 49%">
                        <textarea v-model="offer.udaje_klienta_pravo" class="form-control klient_udaje_top"
                            :placeholder="$t('offer.client_right_placeholder')" @focusin="
                                activated_legend.udaje_klienta_right = true
                                " @focusout="
                                activated_legend.udaje_klienta_right = false
                                " id="floatingTextarea2">
                        </textarea>
                        <label for="floatingTextarea2">{{ $t('offer.client_right_label') }}</label>
                    </div>
                </div>

                <div class="info">
                    <div class="my_tooltip">
                        {{ $t('offer.cover_text_hint') }}
                    </div>
                    <div class="tooltip_hover info_icon">
                        <img src="/img/info_icon.svg" alt="" />
                    </div>
                </div>
                <div class="form-floating textarea mt-1 mb-2">
                    <textarea v-model="offer.text" class="form-control" :placeholder="$t('offer.cover_text_placeholder')"
                        id="floatingTextarea2" @focusin="activated_legend.sprievodny_text = true"
                        @focusout="activated_legend.sprievodny_text = false">
                    </textarea>
                    <label for="floatingTextarea2">{{ $t('offer.cover_text_label') }}</label>
                </div>
            </main>
            <ostatne-nastavenia :offer="offer" :mojefirmy="mojefirmy" :searchMojeFirmy="searchMojeFirmy"
                @kontaktna_osoba="activated_legend.platnost = $event" :premium="premium" :uuidOffer="uuidOffer"
                :currency_data="currency_data" />
            <kontaktna-osoba 
                :personinfo="personinfo" 
                v-bind:uuidOffer="uuidOffer"
                v-bind:preloadedfiles="preloadedfiles" 
                v-bind:moja_firma="offer.mojafirma" 
                @osobaInfo="osoba = $event"
                @kontaktna_osoba="activated_legend.kontaktna_osoba = $event"
                @firemne_udaje="activated_legend.firemne_udaje = $event" 
                v-on:data="file = $event" 
            />
            <offer-files :preloadedofferfiles="preloadedofferfiles" :premium="premium" :uuidOffer="uuidOffer" />
            <offer-one-checkboxes :premium="premium" :options="options" @sendMoznosti="moznosti = $event" />
            <div class="ulozitbtn mb-5 mt-4">
                <div @click="ulozit(0)" class="ulozit mr-2">
                    <span v-show="!saved0">{{ $t('offer.save') }}</span>
                    <div v-show="saved0" class="lds-ellipsis green">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
                <div class="pokracovat" @click="ulozit(1)">
                    <span v-show="!saved1">{{ $t('offer.save_continue') }}</span>
                    <div v-show="saved1" class="lds-ellipsis">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
            </div>
        </section>
        <offer-legend class="offer_legend" :activated="activated_legend" :offer_legend="offer_legend"></offer-legend>

        <klient-create 
            v-if="!max_klient_limit_reached"
            :klientName="klient" :klients="klients" :props_zdroj_kontaktu="props_zdroj_kontaktu"
            :openModal="klientModalStatus" @closeModal="klientModalStatus = $event" @addClient="addClient($event)" />
        <max-offer-modal
            v-if="max_klient_limit_reached && showMaxKlientModal"
            :is_client="true"
            @closeModal="showMaxKlientModal = false"
        />
    </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

import KontaktnaOsoba from "./components/KontaktnaOsoba.vue";
import OfferFiles from "./components/OfferFiles.vue";
import OfferOneCheckboxes from "./components/OfferOneCheckboxes.vue";
import OfferLegend from "./components/OfferLegend.vue";
import OstatneNastavenia from "./components/OstatneNastavenia.vue";
import KlientCreate from "../klient/components/KlientCreate.vue";

export default {
    components: {
        DatePicker,
        KontaktnaOsoba,
        OfferOneCheckboxes,
        OfferFiles,
        OfferLegend,
        OstatneNastavenia,
        KlientCreate,
    },
    props: [
        "main_data",
        "user_template",
        "personinfo",
        "currency_data",
        "mojefirmy",
        "premium",
        "options",
        "uuidOffer",
        "status_offer",
        "preloadedfiles",
        "preloadedofferfiles",
        "new_offer",
        "offer_legend",
        "props_zdroj_kontaktu",
        "is_paid"
    ],
    data() {
        return {
            file: null,
            showMaxKlientModal: false,
            max_klient_limit_reached: false,
            saved1: false,
            saved0: false,
            is_sim_klient: false,
            klientModalStatus: false,
            sim_klient: "",
            klient: "",
            klient_info: {},
            offer: {
                id_klient: "",
                nazov: "",
                verejny_nazov: this.$t ? this.$t('offer.default_title') : 'Cenová ponuka',
                user_provided_id: "",
                mojafirma: "",
                mojafirma_nazov: "",
                platnost: "",
                datum_vystavenia: "",
                text: "",
                udaje_klienta_lavo: "",
                udaje_klienta_pravo: "",
                lang: "",
            },
            errors: {
                klient: false,
                nazov: false,
            },
            osoba: {
                meno: null,
                email: null,
                cislo: null,
                firemne_udaje: null,
            },
            moznosti: {},
            klients: [],
            lastKlients: [],
            activated_legend: {
                verejny_nazov: false,
                udaje_klienta_left: false,
                udaje_klienta_right: false,
                platnost: false,
                sprievodny_text: false,
                kontaktna_osoba: false,
                firemne_udaje: false,
            },
            current_ip: "",
        };
    },
    created() {
        axios.get(`/api/klients`).then((response) => {
            this.klients = response.data;
            // if paid == 0 keep only 3 klients and offer klient also in
            if(this.is_paid == 0){
                this.max_klient_limit_reached = this.klients && this.klients.length >= 3;
                if(this.max_klient_limit_reached){
                    this.klients = this.klients.slice(0, 3);
                }
            }
            if (this.offer.id_klient != null) {
                response.data.forEach((klient) => {
                    if (this.offer.id_klient == klient.id) {
                        this.klient = klient.nazov;
                        if(this.is_paid == 0){
                            this.klients[0] = klient;
                        }
                    }
                });
            }
        });
        axios.post('/api/offer/get_last_clients')
            .then((response) => {
                this.lastKlients = response.data;
                if(this.is_paid == 0){
                    this.lastKlients = this.klients;
                }
            })
            .catch((error) => {
                console.error(error);
            });

        fetch("https://api.ipify.org?format=json")
            .then((x) => x.json())
            .then(({ ip }) => {
                this.current_ip = ip;
            });
    },
    computed: {
        searchMojaFirmaNazov() {
            if (this.is_paid == 0) {
                this.offer.mojafirma_nazov = this.mojefirmy[0].nazov;
                this.offer.mojafirma = this.mojefirmy[0];
                return this.mojefirmy[0];
            }
            if (this.mojefirmy.length > 0) {
                this.mojefirmy.forEach((element) => {
                    if (element.nazov == this.offer.mojafirma_nazov) {
                        this.offer.mojafirma = element;
                    }
                });
            }
            return this.offer.mojafirma;
        },
        searchMojeFirmy() {
            var data = [];
            if (this.mojefirmy.length > 0) {
                this.mojefirmy.forEach((firma) => {
                    data.push(firma.nazov);
                });
            }
            return data;
        },
        searchKlients() {
            var data = [];
            if (this.klient != "") {
                data = this.klients.filter((klient) => {
                    return (
                        klient.nazov &&
                        klient.nazov
                            .toLowerCase()
                            .includes(this.sim_klient.toLowerCase())
                    );
                });
            }
            return data;
        },
        update_last_klient() {
            var data = [];
            var allWidth = $(".last_klients").width();
            this.lastKlients.forEach((klient) => {
                var width =
                    $("<span></span>")
                        .css({ display: "none", whiteSpace: "nowrap" })
                        .appendTo($("body"))
                        .text(klient.nazov)
                        .width() + 24;
                if (allWidth - width <= 5) {
                } else {
                    allWidth = allWidth - width;
                    data.push(klient);
                }
            });
            return data;
        },
    },
    methods: {
        addClientModal() {
            if (this.max_klient_limit_reached) {
                this.showMaxKlientModal = true;
            }else{
                this.klientModalStatus = true;
            }
        },
        addClient(klient) {
            this.klients.push(klient);
            this.offer.id_klient = klient.id;
            this.is_sim_klient = false;
            this.klient = ""
            this.$nextTick(() => {
                this.klient = klient.nazov
            })
        },
        addMojafirma() {
            window.location.href = "/admin/nastavenia/firmy";
        },
        matchName(current) {
            let reggie = new RegExp(this.sim_klient, "ig");
            let found = current.search(reggie) !== -1;
            return !found
                ? current
                : current.replace(reggie, "<b>" + this.sim_klient + "</b>");
        },
        readyToSave() {
            this.ready = true;
            if (this.offer.id_klient == null || this.offer.id_klient == 0) {
                this.ready = false;
                this.errors.klient = true;
                window.scrollTo(0, 0);
            }
            if (this.offer.nazov == "") {
                this.ready = false;
                this.errors.nazov = true;
                window.scrollTo(0, 0);
            }

            return this.ready;
        },
        async ulozit(type) {
            if (!this.offer || typeof this.offer.nazov === "undefined") {
                console.error(
                    "this.offer is undefined or does not have nazov property",
                    this.offer
                );
                return; // Exit the function or handle the error appropriately
            }
            if (this.readyToSave()) {
                type <= 0 ? (this.saved0 = true) : (this.saved1 = true);

                let data = {
                    type: "offer_first",
                    uuid: this.uuidOffer,
                    status_offer: this.status_offer,
                    id_klient: this.offer.id_klient,
                    nazov: this.offer.nazov,
                    verejny_nazov: this.offer.verejny_nazov,
                    user_provided_id: this.offer.user_provided_id,
                    platnost: this.offer.platnost,
                    datum_vystavenia: this.offer.datum_vystavenia,
                    moja_firma: this.offer.mojafirma_nazov
                        ? this.offer.mojafirma_nazov
                        : "",
                    mojafirma_nazov: this.offer.mojafirma_nazov
                        ? this.offer.mojafirma_nazov
                        : "",
                    text: this.offer.text,
                    udaje_klienta_lavo: this.offer.udaje_klienta_lavo,
                    udaje_klienta_pravo: this.offer.udaje_klienta_pravo,
                    lang: this.offer.lang,
                    osoba: this.osoba,
                    moznosti: this.moznosti,
                    current_ip: this.current_ip
                };
                //save Offer
                //if true
                await this.saveOffer(data);
                //saveOfferstatus
                if (this.status_offer != 0) {
                    await this.saveOfferStatus();
                }
                //save podpis
                if (this.file != null) {
                    await this.saveSignature();
                }
                //if all true
                this.errors.klient = false;
                this.errors.nazov = false;
                if (type == 0) {
                    setTimeout(() => {
                        this.saved0 = false;
                        this.message(this.$t('offer.saved_msg'));
                    }, 1000);
                } else if (type == -1) {
                    this.saved0 = false;
                    this.$emit("saveAndCont", data);
                } else {
                    setTimeout(() => {
                        this.saved1 = false;
                    }, 500);
                    this.$emit("saveAndCont", data);
                }
            }
        },
        async saveOfferStatus() {
            await axios
                .post(`/api/offers/offer/status/save`, {
                    uuid: this.uuidOffer,
                    status_offer: 1,
                })
                .then((response) => {
                    return true;
                })
                .catch(function (error) {
                    return false;
                });
        },
        async saveOffer(data) {
            await axios
                .post(`/api/offers/offer/save`, data)
                .then((response) => {
                    this.$emit("offerExam", response.data);
                    return true;
                })
                .catch(function (error) {
                    return false;
                });
        },
        async saveSignature() {
            let fd = null;
            if (typeof this.file.file === "string") {
                fd = {
                    existing: "true",
                    file: this.file,
                    uuid: this.uuidOffer,
                };
            } else {
                fd = new FormData();
                fd.append("existing", "false");
                fd.append("file", this.file.file);
                fd.append("uuid", this.uuidOffer);
            }
            await axios
                .post(`/api/offers/offer/signature/save`, fd)
                .then((response) => {
                    return true;
                })
                .catch(function (error) {
                    return false;
                });
        },
        notBeforeToday(date) {
            return date < new Date(new Date().setHours(0, 0, 0, 0));
        },
        message(text) {
            this.$toast.success(text, {
                position: "top-right",
                timeout: 2038,
                closeOnClick: true,
                pauseOnFocusLoss: true,
                pauseOnHover: true,
                draggable: true,
                draggablePercent: 0.6,
                showCloseButtonOnHover: false,
                hideProgressBar: false,
                closeButton: "button",
                icon: true,
                rtl: false,
            });
        },
    },
    watch: {
        offer(newVal, oldVal) {
        },
        "offer.mojafirma_nazov": function () {
            this.offer.mojafirma = this.searchMojaFirmaNazov;
        },
        klient: function () {
            this.sim_klient = this.klient;
            var id = null;
            this.klients.forEach((klient) => {
                if (this.klient == klient.nazov) {
                    id = klient.id;
                    this.offer.udaje_klienta_lavo = "";
                    this.offer.udaje_klienta_pravo = "";
                    if (klient.spolocnost != null)
                        this.offer.udaje_klienta_lavo +=
                            klient.spolocnost + "\n";
                    if (klient.ulica != null)
                        this.offer.udaje_klienta_lavo +=
                            klient.ulica + "\n";
                    if (klient.psc != null)
                        this.offer.udaje_klienta_lavo += klient.psc + ", ";
                    if (klient.mesto != null)
                        this.offer.udaje_klienta_lavo += klient.mesto;
                    if (klient.ico != null)
                        this.offer.udaje_klienta_pravo += this.$t('offer.ico') + klient.ico + "\n";
                    if (klient.dic != null)
                        this.offer.udaje_klienta_pravo += this.$t('offer.dic') + klient.dic + "\n";
                    if (klient.icdph != null)
                        this.offer.udaje_klienta_pravo += this.$t('offer.icdph') + klient.icdph;
                }
            });
            this.is_sim_klient = true;
            if (id != null) {
                this.is_sim_klient = false;
            }
            if (this.klient == "") this.is_sim_klient = false;

            this.offer.id_klient = id;
        },
        "offer.id_klient": function () {
            if (this.offer.id_klient != null) {
                this.klients.forEach((klient) => {
                    if (this.offer.id_klient == klient.id) {
                        this.klient = klient.nazov;
                    }
                });
            }
        },
        "offer.nazov": function () {
            if (this.offer.nazov == "") {
                this.errors.nazov = true;
            } else {
                this.errors.nazov = false;
            }
        },
        main_data() {
            this.offer = this.main_data;
        },
    },
};
</script>
<style lang="scss">
.combobox_mojefirmy {
    margin-top: 15px;

    .v-menu {
        .v-menu__content {
            left: 0 !important;
        }
    }

    .v-input {
        height: 56px;
        width: 100%;

        .v-input__control {
            height: 56px !important;
        }
    }

    .theme--light.v-text-field--filled>.v-input__control>.v-input__slot {
        background: #fff;
    }

    input {
        font-family: Roboto !important;
        font-style: normal !important;
        font-weight: bold !important;
        font-size: 14px !important;
        line-height: 16px !important;
        color: #212541 !important;
    }

    .v-input__slot,
    .theme--light.v-text-field--filled>.v-input__control>.v-input__slot {
        background: #fff !important;
        border: 1px solid #dde3e8 !important;
        border-radius: 0 !important;

        input {
            font-style: normal;
            font-weight: normal;
            font-size: 14px;
            line-height: 16px;
            color: #212541 !important;
        }
    }

    .v-text-field>.v-input__control>.v-input__slot {
        &:after {
            content: none !important;
        }

        &:before {
            content: none !important;
        }
    }

    .v-label.v-label--active.theme--light {
        left: -11px !important;
        top: 14px !important;
        font-family: Roboto !important;
        font-style: normal !important;
        font-weight: bold !important;
        font-size: 11px !important;
        line-height: 13px !important;
        letter-spacing: 0.1em !important;
        text-transform: uppercase !important;
        color: #9598a7 !important;
        margin-top: 0 !important;
    }

    .v-label.theme--light {
        top: 22px !important;
        font-family: Roboto !important;
        font-style: normal !important;
        font-weight: bold !important;
        font-size: 11px !important;
        line-height: 13px !important;
        letter-spacing: 0.1em !important;
        text-transform: uppercase !important;
        color: #9598a7 !important;
        margin-top: 0 !important;
    }
}
</style>
<style lang="scss" scoped>
.client-info {
    @media (max-width: 600px) {
        flex-direction: column;
        gap: 10px;
        & .textarea {
            width: 100% !important;
        }
    }
}
.offer_legend {
    @media (max-width: 600px) {
        display: none !important;
    }
}
.offer_one_legend {
    margin-top: 30px;
    margin-left: 100px;
    display: flex;
    align-items: flex-start;
    gap: 68px;

    @media (max-width: 1350px) {
        margin-left: 20px;
    }

    @media (max-width: 1100px) {
        gap: 20px;
        margin-left: 0px;
    }
}

.sup {
    color: #f83d34;
    font-size: 13px;
}

.jazyky {
    display: flex;
    width: 90%;
    gap: 30px;
    align-items: center;
    @media (max-width: 600px) {
        flex-direction: column;
        align-items: flex-start;
        gap: 5px;
    }
}

.noPremium {
    position: relative;
}

textarea.klient_udaje_top {
    padding-top: 3px !important;

    @media screen and (max-width: 1450px) {
        padding-top: 15px !important;
    }
}

.ColorBox {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    width: 510px;
    height: 41px;
    background: #fff7ed;
    border: 1px solid #fbbf24;
    box-sizing: border-box;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;

    @media screen and (max-width: 700px) {
        width: auto;
        height: fit-content;
        padding: 5px;
    }

    svg {
        width: 21px;
        height: 14px;
        margin-right: 13px;
    }

    div {
        font-family: Roboto;
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 19px;
        color: #9a3412;

        b {
            font-weight: 600;
        }

        a {
            font-weight: 600;
            text-decoration: underline;
            color: #9a3412;

            &:hover {
                color: #9a3412;
                text-decoration: underline;
            }
        }
    }
}

.jazyk {
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 11px;
    line-height: 13px;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: #9598a7;
    padding: 20px 0 0 0;
    margin-bottom: 0;
}

.check {
    position: relative;
    width: fit-content;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 16px;
    margin-top: 15px;

    span.check_txt {
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 16px;
        color: #212541;
    }

    &:hover {
        .tooltip_jazyk {
            opacity: 1 !important;
        }
    }

    .tooltip_jazyk {
        pointer-events: none;
        opacity: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 125px;
        background: #f3385a;
        box-shadow: 0px 2px 2px rgb(143 153 179 / 20%);
        border-radius: 6px;
        font-weight: 800;
        font-size: 14px;
        line-height: 18px;
        color: #fff;
        padding: 10px;
        position: absolute;
        top: -50px;
        right: -1px;
        z-index: 10000;
        transition: opacity 0.5s ease-in-out;

        &::after {
            content: "";
            width: 15px;
            height: 15px;
            background: #f3385a;
            position: absolute;
            right: 10px;
            bottom: -3px;
            transform: rotate(45deg);
            border-radius: 3px;
        }
    }

    .check_container {
        position: relative;
        cursor: pointer;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        width: 16px;
        height: 16px;
        margin-right: 5px;
        margin-bottom: 5px;
    }

    .check_container input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;
    }

    .check_checkmark {
        position: absolute;
        top: 0;
        left: 0;
        height: 16px;
        width: 16px;
        background-color: #ffffff;
        border: 1px solid #212541;
        border-radius: 3px;
    }

    .check_container:hover input~.check_checkmark {
        background-color: #ffffff;
    }

    .check_container input:checked~.check_checkmark {
        background-color: #212541;
    }

    .check_checkmark:after {
        content: "";
        position: absolute;
        display: none;
    }

    .check_container input:checked~.check_checkmark:after {
        display: block;
    }

    .check_container .check_checkmark:after {
        left: 5px;
        top: 1px;
        width: 5px;
        height: 10px;
        border: 1px solid #fff;
        border-width: 0 2px 2px 0;
        transform: rotate(45deg);
    }
}

.info {
    position: relative;
    height: 20px;
    margin-left: 10px;

    .info_icon {
        pointer-events: all;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 20px;
        height: 20px;
        float: right;

        img {
            width: 80%;
            height: 80%;
        }
    }

    .my_tooltip {
        bottom: 22px;
        right: -7px;
    }
}

.agree_tooltip {
    position: relative;
}

.my_tooltip {
    pointer-events: none;
    opacity: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 300px;
    background: #f3385a;
    box-shadow: 0px 2px 2px rgba(143, 153, 179, 0.2);
    border-radius: 6px;
    font-weight: 800;
    font-size: 14px;
    line-height: 18px;
    color: #fff;
    padding: 10px;
    position: absolute;
    top: unset;
    right: 15px;
    z-index: 10000;
    transition: opacity 0.5s ease-in-out;

    &::after {
        content: "";
        width: 15px;
        height: 15px;
        background: #f3385a;
        position: absolute;
        right: 10px;
        bottom: -3px;
        transform: rotate(45deg);
        border-radius: 3px;
    }
}

.klient_sim {
    display: grid;
    position: absolute;
    top: 58px;
    left: 0;
    width: auto;
    height: auto;
    background: #ffffff;
    border: 1px solid #dde3e8;
    border-top: 0;
    box-sizing: border-box;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
    z-index: 1000;
    pointer-events: all;

    span {
        font-family: Roboto;
        font-style: normal;
        font-weight: 500;
        font-size: 13px;
        line-height: 15px;
        color: #212541;
        padding: 13px;
        cursor: pointer;

        &:hover {
            color: #2ed8b6;
        }
    }

    .nothing {
        .top {
            font-family: Roboto;
            font-style: italic;
            font-weight: normal;
            font-size: 13px;
            line-height: 15px;
            color: #000000;
            padding: 22px;
        }
    }

    .bottom {
        font-family: Roboto;
        font-style: normal;
        font-weight: bold;
        font-size: 14px;
        line-height: 16px;
        padding: 22px;
        color: #2ed8b6;
        cursor: pointer;
        border-top: 1px solid #9598a7;
    }
}

.form-floating {
    position: relative;

    .lupa {
        position: absolute;
        right: 6px;
        top: 0;
        bottom: 0;
        margin: auto;
    }
}

.last_klients {
    width: 100%;
    display: flex;
    margin-top: 10px;
    @media (max-width: 600px) {
        margin: 10px auto;
        flex-direction: column;
        gap: 10px;
    }
    span {
        width: auto;
        height: auto;

        background: #f2f7fb;
        border-radius: 4px;
        transition: 0.5s ease-in-out all;

        padding: 12px;
        margin-right: 6px;

        display: flex;
        align-items: center;
        justify-content: center;

        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 13px;
        line-height: 15px;
        text-align: center;
        color: #212541;

        cursor: pointer;

        &:hover {
            background: #dcecfa;
        }
    }
}

.error {
    border: 1px solid #dc3545 !important;
}

.one_cont {
    width: 560px;

    @media (max-width: 600px) {
        width: 95%;
    }

    h1 {
        font-style: normal;
        font-weight: 500;
        font-size: 36px;
        line-height: 45px;
        color: #212541;
        @media (max-width: 600px) {
            font-size: 24px;
            line-height: 30px;
        }
    }

    textarea,
    input {
        font-family: Roboto;
        font-style: normal;
        font-weight: bold;
        font-size: 14px;
        line-height: 16px;
        display: flex;
        align-items: center;

        color: #212541;

        border: 1px solid #dde3e8;
        border-radius: 0;
    }

    .ulozitbtn {
        width: 100%;
        display: flex;
        justify-content: flex-end;

        .ulozit {
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;

            width: 103px;
            height: 55px;
            border: 1px solid #2ed8b6;
            box-sizing: border-box;
            border-radius: 4px;
            font-family: Roboto;
            font-style: normal;
            font-weight: bold;
            font-size: 16px;
            line-height: 19px;
            text-align: center;
            color: #2ed8b6;
        }

        .pokracovat {
            margin-left: 20px;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: space-around;

            width: 200px;
            height: 55px;
            background: #2ed8b6;
            box-sizing: border-box;
            border-radius: 4px;
            font-family: Roboto;
            font-style: normal;
            font-weight: 800;
            font-size: 17px;
            line-height: 182.5%;
            text-align: center;
            color: #ffffff;
            transition: 0.5s ease-in-out all;

            img {
                transition: 0.5s ease-in-out all;
                transform: translateX(0px);
            }

            &:hover {
                img {
                    transform: translateX(15px);
                }
            }
        }
    }

    .float-container {
        border: 1px solid #dde3e8;
        border-radius: 0;
        margin-top: 20px;
    }

    .form-floating {
        margin-top: 20px;
    }

    .form-floating>label {
        padding: 22px 13px;
    }

    .form-floating>label,
    .float-container label {
        font-family: Roboto;
        font-style: normal;
        font-weight: bold;
        font-size: 11px;
        line-height: 13px;
        letter-spacing: 0.1em;
        text-transform: uppercase;
        color: #9598a7;
        margin-top: 0;
    }

    .first {
        width: 100%;
        padding: 20px;
        background: #ffffff;
        box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.05);
        border-radius: 4px;

        margin-top: 20px;

        .textarea {
            border: 1px solid #dde3e8;
            border-radius: 0;

            textarea {
                border: none !important;
                border-top: 25px solid transparent !important;
                padding-top: 0;
                width: 100%;
                height: 120px;
                background: #ffffff;
                box-sizing: border-box;
            }
        }

        .dateInput {
            display: grid;
        }

        .dateInput .mx-input {
            box-shadow: none !important;
            -webkit-box-shadow: none !important;
        }

        .dateInput .mx-datepicker {
            width: 100% !important;
        }

        .dateInput path {
            fill: #383c4c !important;
        }
    }
}

.lds-ellipsis {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
}

.lds-ellipsis.green div {
    background: #2ed8b6;
}

.lds-ellipsis div {
    position: absolute;
    top: 33px;
    width: 13px;
    height: 13px;
    border-radius: 50%;
    background: #fff;
    animation-timing-function: cubic-bezier(0, 1, 1, 0);
}

.lds-ellipsis div:nth-child(1) {
    left: 8px;
    animation: lds-ellipsis1 0.6s infinite;
}

.lds-ellipsis div:nth-child(2) {
    left: 8px;
    animation: lds-ellipsis2 0.6s infinite;
}

.lds-ellipsis div:nth-child(3) {
    left: 32px;
    animation: lds-ellipsis2 0.6s infinite;
}

.lds-ellipsis div:nth-child(4) {
    left: 56px;
    animation: lds-ellipsis3 0.6s infinite;
}

@keyframes lds-ellipsis1 {
    0% {
        transform: scale(0);
    }

    100% {
        transform: scale(1);
    }
}

@keyframes lds-ellipsis3 {
    0% {
        transform: scale(1);
    }

    100% {
        transform: scale(0);
    }
}

@keyframes lds-ellipsis2 {
    0% {
        transform: translate(0, 0);
    }

    100% {
        transform: translate(24px, 0);
    }
}
</style>
